import { render, staticRenderFns } from "./HomepageBecomeInstructor.vue?vue&type=template&id=653492a6&"
import script from "./HomepageBecomeInstructor.vue?vue&type=script&lang=js&"
export * from "./HomepageBecomeInstructor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports